import GlobalText from 'texts/Global';

import { SPECIALISATION_TO_DETAILS } from 'globals/constants';
import ServerErrorToText from 'texts/ServerErrorToText';

export const createGenericSorter = dataIndex => (a, b) => {
  if (a[dataIndex] < b[dataIndex]) {
    return -1;
  }
  if (a[dataIndex] > b[dataIndex]) {
    return 1;
  }
  return 0;
};

export const createMomentSorter = dataIndex => (momentA, momentB) => {
  if (momentA[dataIndex].isBefore(momentB[dataIndex])) {
    return -1;
  }
  if (momentA[dataIndex].isAfter(momentB[dataIndex])) {
    return 1;
  }
  return 0;
};

/**
 * Create Ant Table dataSource from the Formik values.
 *  The field names of the Formik values will be used as row keys.
 *  The Ant Table will consist of two columns:
 *  1. 'name' column will be populated using the corresponding SharedText values
 *  2. 'value' column will be populated using the corresponding values
 *
 * @param   {Object}    values  Formik values
 *
 * @returns {Object[]}          Ant Table dataSource
 */
export const generalValuesToDataSource = values =>
  Object.keys(values).map(fieldName => ({
    key: fieldName,
    name: GlobalText[fieldName],
    value: values[fieldName],
  }));

// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export const formatFileSize = (numBytes, decimals = 2) => {
  if (numBytes === 0) return '0 B';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(numBytes) / Math.log(k));

  return `${parseFloat(numBytes / k ** i).toFixed(dm)} ${units[i]}`;
};

export const resolveServerValidationErrorMessages = errors => {
  const newErrors = {};
  Object.keys(errors).forEach(key => {
    if (typeof errors[key] === 'string') {
      newErrors[key] = ServerErrorToText[errors[key]] || errors[key];
    } else if (errors[key] !== null) {
      newErrors[key] = resolveServerValidationErrorMessages(errors[key]);
    }
  });
  return newErrors;
};

export const academicSessionGenerator = year => {
  return `${year} / ${year + 1}`;
};

export const sleep = milliseconds =>
  new Promise(resolve => setTimeout(resolve, milliseconds));

export const getSpecialisationFromLocation = location => {
  const matches = location.pathname.match(/^\/(\w+)/);
  return matches === null || SPECIALISATION_TO_DETAILS[matches[1]] === undefined
    ? null
    : matches[1];
};
